import { RawCollection } from '../types';
import { markItemForRemoval } from './markItemForRemoval';

interface UnmarkItemForRemovalProps {
    itemId: string;

    /**
     * collectionId is optional, but it's a slight optimization if we know it.
     */
    collectionId?: string;
}

export const unmarkItemForRemoval = (oldData: RawCollection[], { itemId, collectionId }: UnmarkItemForRemovalProps) =>
    markItemForRemoval(oldData, { itemId, collectionId, pendingRemoval: false });
